const TOKEN_KEY = "duomatt.family-token";
export const AUTH_CHANGED_EVENT = "duomatt:auth-changed";

export function getFamilyToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setFamilyToken(token: string | null): void {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}
